import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

/**
 * @param {string} selector - Wrapper fields selector
 * @param {Object} options - Configuration
 * @param {Object} options.fields - Birth date fields
 * @returns {BirthDateValidation}
 */
export class BirthDateValidation {
    wrapper;
    fields = {};
    format;
    error;
    messages;
  
    constructor(selector = '', { fields, messages } = { fields: { day: { selector: '', format: '' }, month: { selector: '', format: '' }, year: { selector: '', format: '' } }, messages: { invalid: '', date: '' } }) {
      this.wrapper = document.querySelector(selector);
      this.format = this.getFormat(fields);
      this.messages = { invalid: 'Fecha inválida', date: 'Debes ser mayor de edad', ...messages };
  
      for (const key in fields) this.fields[key] = new Field(fields[key].selector);
  
      this.error = new FieldError('custom-birth-date-error', {
        wrapper: this.wrapper,
        on: {
          show: () => {
            this.fields?.day?.target?.focus();
            this.toggleError('add');
          },
          hide: () => this.toggleError('remove')
        }
      });
      
      switch (this.format) {
        case 'YYYY-MM-DD':
        case 'YYYY-M-D':
          break;
        default:
          console.warn('Formato de fecha no válido. Ver más en https://day.js.org/docs/en/display/format');
          break;
      }
    }
  
    validate() {
      if (typeof dayjs === 'undefined') return console.warn('No esta definida la variable dayjs');
      let { day, month, year } = this.fields;
      const current_day = dayjs();
  
      if (!day.getValue() || !month.getValue() || !year.getValue()) return this.error.hide();
      let birthDate = dayjs(`${year.getValue()}-${month.getValue()}-${day.getValue()}`, this.format, true);
  
      if (!birthDate.isValid()) return this.error.show(this.messages.invalid, 'invalid');
      else {
        let ageUser = current_day.diff(birthDate, 'year');
        if (ageUser < 18) return this.error.show(this.messages.date, 'date');
        else return this.error.hide();
      }
    }
  
    toggleError(type = 'add') {
      this.wrapper.classList[type]('wrapper-birthdate-error');
      for (const key in this.fields) {
        if (this.fields[key]) this.fields[key].toggleClass("error", type);
      }
    }
  
    getFormat(fields) {
      const day = fields.day?.format || 'DD';
      const month = fields.month?.format || 'MM';
      const year = fields.year?.format || 'YYYY';
      return `${year}-${month}-${day}`;
    }
  
    getFields() {
      return this.fields;
    }
  }
  
  
  class Field {
    target;
  
    constructor(selector) {
      this.target = document.querySelector(selector);
    }
  
    getValue() {
      return this.target?.value
    }
  
    toggleClass(className, type = "add") {
      this.target?.classList[type](className);
    }
  }
  
  
  class FieldError {
    id;
    options;
  
    constructor(id, options) {
      this.id = id;
      this.options = options || {};
    }
  
    getTarget() {
      return document.getElementById(this.id);
    }
  
    create(message) {
      let { wrapper } = this.options;
      wrapper.insertAdjacentHTML('beforeend', `<div id="${this.id}" class="error-message">${message}</div>`)
    }
  
    show(message = 'Error', errorType) {
      let { on, wrapper } = this.options;
      let target = this.getTarget();
      if (target) target.innerHTML = message;
      else if (wrapper) this.create(message);
      on?.show?.();
      return { isValid: false, errorType }
    }
  
    hide() {
      let { on } = this.options;
      this.getTarget()?.remove();
      on?.hide?.();
      return { isValid: true };
    }
  }